import * as React from 'react'
import * as UniversalRouter from 'universal-router'
import {StatusConnected} from './component'
import * as Constants from './constants'

export const routes = [
  {
    action: (context: UniversalRouter.ActionContext) => <StatusConnected />,
    path: `${Constants.URL_HOME}`,
  },
]
